module.exports = __webpack_public_path__ + "img/avatar6.13327c7c.png";